<template>
	<div>
		<titles titlename="权限管理" titlecontent="这里可以管理权限" :mbx="paths"></titles>
		<manges :pagesobj="pagesobj" :tabtitlelist="tabtitlelsit" :mangesname="mangesname" :tablist="tablist"></manges>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import manges from '@/components/mangeslist/manges.vue';
import { GetqxPageAuthList } from '@/request/api/mange/mange.js';
import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			pagesobj: {
				pageIndex: 1,
				pageSize: 5,
				pro_name: '',
				maxpages: null,
				au_parentGuid: '',
				au_name: ''
			},
			mangesname: {
				name: '权限',
				topcolor: '#17A00E',
				contentcolor: '#6571FF',
				show: false
			},
			tabtitlelsit: [
				{
					label: '权限名称',
					prop: 'au_name'
				},
				{
					label: '系统编号',
					prop: 'au_sysCode'
				},
				{
					label: '备注',
					prop: 'au_remark'
				}
			],

			tablist: [],

			// 标题组件
			paths: [
				{
					path: '/authoritymange/authority',
					name: '权限管理'
				}
			]
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getauthority(this.pagesobj);
	},
	methods: {
		getauthority(pagecrofobj = this.pagesobj) {
			GetqxPageAuthList(pagecrofobj).then(res => {
				console.log(res);
				this.tablist = res.data.data.list;
				this.pagesobj.maxpages = res.data.data.totalCount;
			});
		}
	},
	components: {
		titles,
		manges
	}
};
</script>

<style></style>
